import { Button } from "@/components/ui/button";
import { PhoneCall, CalendarClock, X, RotateCcw, MessageCircle } from "lucide-react";

/** Botones de accion sobre un ciclo de seguimiento (contactar/posponer/
 * descartar/reactivar). `testIds` recibe los prefijos data-testid propios
 * de cada contexto (panel de Seguimiento vs. ficha del paciente). */
export default function FollowUpActionButtons({ treatment, onContact, onWhatsApp, onPostpone, onDiscard, onReactivate, testIds }) {
  if (treatment.follow_up_status === "discarded") {
    return (
      <Button size="sm" variant="outline" onClick={() => onReactivate(treatment)} data-testid={`${testIds.reactivate}${treatment.id}`}>
        <RotateCcw className="w-3.5 h-3.5" /> Reactivar
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <Button size="sm" variant="outline" onClick={() => onContact(treatment)} data-testid={`${testIds.contact}${treatment.id}`}>
        <PhoneCall className="w-3.5 h-3.5" /> Contactar
      </Button>
      {onWhatsApp && (
        <Button size="sm" variant="outline" onClick={() => onWhatsApp(treatment)} data-testid={`${testIds.whatsapp}${treatment.id}`}>
          <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
        </Button>
      )}
      <Button size="sm" variant="outline" onClick={() => onPostpone(treatment)} data-testid={`${testIds.postpone}${treatment.id}`}>
        <CalendarClock className="w-3.5 h-3.5" /> Posponer
      </Button>
      <Button size="sm" variant="ghost" className="text-destructive hover:text-destructive" onClick={() => onDiscard(treatment)} data-testid={`${testIds.discard}${treatment.id}`}>
        <X className="w-3.5 h-3.5" /> Descartar
      </Button>
    </div>
  );
}
